import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VendorService } from '@controlling/proxy/controlling/controllers/vendor.service';

FieldBuilder.setNamespace('General');

export const RESTDAY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.RestDay.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('code', 'Entity.RestDay.Code')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .checkbox('isRestDay', 'Entity.RestDay.IsRestDay')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .display('fantasyName')
    .keyField('id')
    .build(),
];

export const RESTDAY_CONFIG = {
  entityName: 'RestDay',
  localizationKey: 'General::Entity.RestDay',
  fields: RESTDAY_FIELDS,
  permission: 'ControllingCalendar.RestDays',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
